import React, { useState } from "react";
import { Link } from "react-router-dom";
import streams from "../../data/streams";

const CSS = `
  .pf-streams { min-height: 100vh; padding: 110px 0 80px; position: relative; }
  .pf-streams-wrap { max-width: 1000px; margin: 0 auto; padding: 0 24px; position: relative; z-index: 1; }

  .pf-stream-tabs {
    display: flex; gap: 8px; flex-wrap: wrap; justify-content: center;
    margin: 40px 0 36px;
  }
  .pf-stream-tab {
    padding: 10px 22px; border-radius: 50px; font-size: 0.84em; font-weight: 700;
    background: rgba(255,255,255,0.03); border: 1.5px solid rgba(255,255,255,0.06);
    color: rgba(240,240,245,0.4); cursor: pointer;
    transition: all 0.3s ease; display: inline-flex; align-items: center; gap: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .pf-stream-tab:hover {
    background: rgba(255,255,255,0.05); border-color: rgba(255,255,255,0.1); color: rgba(240,240,245,0.7);
  }
  .pf-stream-tab.active {
    border-color: rgba(255,107,53,0.3); color: #FF6B35;
    background: rgba(255,107,53,0.08);
  }

  /* stream detail */
  .pf-stream-detail {
    border-radius: 24px; overflow: hidden;
    border: 1px solid rgba(255,255,255,0.05);
    animation: fadeInUp 0.5s ease both;
  }
  .pf-stream-header {
    padding: 36px 36px 28px; position: relative;
  }
  .pf-stream-header-top { display: flex; align-items: center; gap: 16px; margin-bottom: 14px; }
  .pf-stream-icon {
    width: 60px; height: 60px; border-radius: 18px;
    display: flex; align-items: center; justify-content: center;
    font-size: 1.8em;
  }
  .pf-stream-title {
    font-family: 'DM Serif Display', serif; font-size: 1.6em; color: #F0F0F5;
  }
  .pf-stream-tagline { font-size: 0.82em; color: rgba(240,240,245,0.35); margin-top: 2px; }
  .pf-stream-desc {
    font-size: 0.92em; color: rgba(240,240,245,0.48); line-height: 1.8;
  }
  .pf-stream-diff {
    display: inline-flex; align-items: center; gap: 6px; margin-top: 14px;
    font-size: 0.78em; font-weight: 600; color: rgba(240,240,245,0.35);
  }
  .pf-stream-diff-bar {
    display: flex; gap: 3px;
  }
  .pf-stream-diff-dot {
    width: 14px; height: 6px; border-radius: 3px;
    background: rgba(255,255,255,0.06);
  }
  .pf-stream-diff-dot.filled {
    background: #FF6B35;
  }

  .pf-stream-body { padding: 0 36px 36px; }
  .pf-stream-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 20px; }

  .pf-stream-block {
    padding: 22px; border-radius: 16px;
    background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.04);
  }
  .pf-stream-block-title {
    font-weight: 700; font-size: 0.85em; color: #F0F0F5; margin-bottom: 12px;
    display: flex; align-items: center; gap: 8px;
  }
  .pf-stream-block-list { list-style: none; padding: 0; margin: 0; }
  .pf-stream-block-list li {
    padding: 6px 0; font-size: 0.82em; color: rgba(240,240,245,0.45);
    display: flex; align-items: flex-start; gap: 8px; line-height: 1.5;
  }
  .pf-stream-block-list li::before { content: '›'; color: #FF6B35; font-weight: 700; flex-shrink: 0; }

  .pf-stream-tags { display: flex; flex-wrap: wrap; gap: 6px; }
  .pf-stream-tag {
    padding: 5px 14px; border-radius: 20px; font-size: 0.75em; font-weight: 600;
    background: rgba(0,212,170,0.06); border: 1px solid rgba(0,212,170,0.12);
    color: rgba(0,212,170,0.7);
  }
  .pf-stream-exam-tag {
    padding: 5px 14px; border-radius: 20px; font-size: 0.75em; font-weight: 600;
    background: rgba(124,92,252,0.06); border: 1px solid rgba(124,92,252,0.12);
    color: rgba(124,92,252,0.7);
  }

  .pf-stream-suitable {
    padding: 16px 20px; border-radius: 14px; margin-top: 16px;
    background: rgba(255,107,53,0.04); border: 1px solid rgba(255,107,53,0.1);
    font-size: 0.85em; color: rgba(240,240,245,0.5); line-height: 1.7;
  }
  .pf-stream-suitable strong { color: #FF6B35; font-weight: 700; }

  .pf-stream-cta { text-align: center; margin-top: 44px; }

  @media(max-width: 768px) {
    .pf-stream-grid { grid-template-columns: 1fr; }
    .pf-stream-header, .pf-stream-body { padding-left: 20px; padding-right: 20px; }
  }
`;

export default function StreamGuide() {
  const [active, setActive] = useState(0);
  const stream = streams[active];

  return (
    <>
      <style>{CSS}</style>
      <section className="pf-streams">
        <div className="pf-streams-wrap">
          <div style={{ textAlign: "center" }}>
            <div className="section-badge">📚 Stream Guide</div>
            <h1 className="section-title">
              Which Stream After <em>10th?</em>
            </h1>
            <p className="section-subtitle" style={{ margin: "0 auto" }}>
              Science, Commerce, Arts, Diploma, or ITI — understand each
              stream's advantages, career paths, and which one suits your
              personality.
            </p>
          </div>

          <div className="pf-stream-tabs">
            {streams.map((s, i) => (
              <button
                key={s.id}
                className={`pf-stream-tab${active === i ? " active" : ""}`}
                onClick={() => setActive(i)}
              >
                <span>{s.emoji}</span>
                {s.title.split("(")[0].trim()}
              </button>
            ))}
          </div>

          <div className="pf-stream-detail" key={stream.id}>
            <div
              className="pf-stream-header"
              style={{ background: `${stream.color}08` }}
            >
              <div className="pf-stream-header-top">
                <div
                  className="pf-stream-icon"
                  style={{
                    background: `${stream.color}15`,
                    border: `1px solid ${stream.color}25`,
                  }}
                >
                  {stream.emoji}
                </div>
                <div>
                  <h2 className="pf-stream-title">{stream.title}</h2>
                  <div className="pf-stream-tagline">{stream.tagline}</div>
                </div>
              </div>
              <p className="pf-stream-desc">{stream.description}</p>
              <div className="pf-stream-diff">
                Difficulty:
                <div className="pf-stream-diff-bar">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <div
                      key={n}
                      className={`pf-stream-diff-dot${n <= stream.difficulty ? " filled" : ""}`}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="pf-stream-body">
              <div className="pf-stream-grid">
                {/* Careers */}
                <div className="pf-stream-block">
                  <div className="pf-stream-block-title">
                    💼 Career Paths Available
                  </div>
                  <div className="pf-stream-tags">
                    {stream.careers.map((c, i) => (
                      <span className="pf-stream-tag" key={i}>
                        {c}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Exams */}
                <div className="pf-stream-block">
                  <div className="pf-stream-block-title">
                    📝 Key Entrance Exams
                  </div>
                  <div className="pf-stream-tags">
                    {stream.topExams.map((e, i) => (
                      <span className="pf-stream-exam-tag" key={i}>
                        {e}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Advantages */}
                <div
                  className="pf-stream-block"
                  style={{ gridColumn: "1 / -1" }}
                >
                  <div className="pf-stream-block-title">✅ Key Advantages</div>
                  <ul className="pf-stream-block-list">
                    {stream.advantages.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="pf-stream-suitable">
                <strong>Best For: </strong>
                {stream.suitableFor}
              </div>
            </div>
          </div>

          <div className="pf-stream-cta">
            <Link to="/test" className="btn-primary">
              🧭 Still Confused? Take the Career Test
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
